<script setup>
import { computed } from "vue";

const props = defineProps({
  content: String,
});
const result = computed(() => props.content.split("\n"));
</script>

<template>
  <p v-for="(paragraph, index) of result" v-text="paragraph" :key="index" />
</template>

<style scoped></style>
